import { appVersion, env } from '@/config/env'
import Appsignal from '@appsignal/javascript'

export const appsignal =
  import.meta.env.PROD && env.appsignalPushApiKey
    ? new Appsignal({
        key: env.appsignalPushApiKey,
        revision: appVersion,
        namespace: 'Resupply Driver PWA',
      })
    : null
